import { connect } from 'react-redux';
import DepartmentDetails from "./DepartmentDetails";
import {
    fetchGetDepartmentData,
    getDepartmentAndStaffData,
    getDepartmentId,
    loadingDepartment,
    getFetchingErrorDepartment,
    resetDepartmentData,
    setDepartmentId
} from "../../../reducers/organization/department";
import { fetchGetAllStaffMembers, getAllActiveStaffMembers } from "../../../reducers/organization/staffMembers";
import { getTranslation } from "../../../reducers/common/localization";
import {
    MODAL_REMOVE_EMPLOYEE_FROM_DEPARTMENT,
    MODAL_ADD_EMPLOYEE_TO_DEPARTMENT,
    MODAL_EDIT_DEPARTMENT, showModal
} from "../../../reducers/common/activeModal";
import { resetSubmitFormData } from "../../../reducers/common/submitForm";
import { Utils } from "../../../utils/utils";

const mapStateToProps = (state, { location }) => {
    let pathId = Utils.getParamsFromLocationSearch(location.search).id;

    return {
        id: getDepartmentId(state),
        pathId: pathId,
        data: getDepartmentAndStaffData(state),
        loading: loadingDepartment(state),
        fetchingError: getFetchingErrorDepartment(state),
        employees: getAllActiveStaffMembers(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: id => dispatch(fetchGetDepartmentData(id)),
        onEmployeesLoad: () => dispatch(fetchGetAllStaffMembers()),
        onDepartmentSet: (id) => dispatch(setDepartmentId(id)),
        onEditDepartment: () => {
            dispatch(showModal({ modalKey: MODAL_EDIT_DEPARTMENT }));
            dispatch(resetSubmitFormData());
        },
        onAddEmployeeToDepartment: () => {
            dispatch(showModal({ modalKey: MODAL_ADD_EMPLOYEE_TO_DEPARTMENT }));
            dispatch(resetSubmitFormData());
        },
        onRemoveEmployeeFromDepartment: () => {
            dispatch(showModal({ modalKey: MODAL_REMOVE_EMPLOYEE_FROM_DEPARTMENT }));
            dispatch(resetSubmitFormData());
        },
        onUnmount: () => {
            dispatch(setDepartmentId(null));
            dispatch(resetDepartmentData());
            dispatch(resetSubmitFormData());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DepartmentDetails);



// WEBPACK FOOTER //
// ./src/components/staffMemberManagement/departmentDetails/DepartmentDetails.container.js